import React from "react";
import { useAppData } from "../../context/Contexts";
import { VehicleAddonItem, useVehicleAddonsQuery } from "../../services/VehicleAddonsService";
import styles from "./styles.module.scss";

export default function VehicleAddons() {
    const { currentAppData, setCurrentAppData } = useAppData();

    const { data: addons } = useVehicleAddonsQuery({
        year: currentAppData?.year,
        make: currentAppData?.make,
        model: currentAppData?.model,
        trim: currentAppData?.trim,
        cab: currentAppData?.cab,
    });

    if (!addons || addons.length === 0) {
        return null;
    }

    const isSelected = (addon: VehicleAddonItem) =>
        (currentAppData?.selectedVehicleAddons ?? []).some(
            (a) => a.variantId === addon.variantId
        );

    const handleToggle = (addon: VehicleAddonItem) => {
        const selected = currentAppData?.selectedVehicleAddons ?? [];
        const updated = isSelected(addon)
            ? selected.filter((a) => a.variantId !== addon.variantId)
            : [...selected, addon];

        setCurrentAppData((prev) => ({ ...prev, selectedVehicleAddons: updated }));
    };

    return (
        <div className={styles.container}>
            <div className={styles.divider}>
                <span className={styles.dividerLabel}>OPTIONAL</span>
            </div>

            {addons.map((addon) => {
                const savingsAmount =
                    addon.compareAtPrice != null
                        ? (
                              parseFloat(addon.compareAtPrice) -
                              parseFloat(addon.price)
                          ).toFixed(0)
                        : null;

                return (
                    <div key={addon.variantId} className={styles.addonCard}>
                        {addon.image ? (
                            <img
                                src={addon.image}
                                alt={addon.productName}
                                className={styles.addonImage}
                            />
                        ) : (
                            <div className={styles.addonImagePlaceholder} />
                        )}

                        <div className={styles.addonInfo}>
                            <div className={styles.addonName}>{addon.productName}</div>

                            <div className={styles.priceRowContainer}>
                            <div className={`${styles.special_price_title}`}>Your Special Price</div>
                            <div className={styles.priceRow}>
                                
                                {addon.compareAtPrice && (
                                    <s className={styles.comparePrice}>
                                        ${parseFloat(addon.compareAtPrice).toFixed(2)}
                                    </s>
                                )}
                                <span className={styles.price}>
                                    ${parseFloat(addon.price).toFixed(2)}
                                </span>
                                {savingsAmount && (
                                    <span className={styles.saveBadge}>
                                        Save ${savingsAmount} Today!
                                    </span>
                                )}
                            </div>
                            </div>
                        </div>

                        <label className={styles.toggle} aria-label={`Add ${addon.productName} to cart`}>
                            <input
                                type="checkbox"
                                aria-label={`Add ${addon.productName}`}
                                checked={isSelected(addon)}
                                onChange={() => handleToggle(addon)}
                            />
                            <span className={styles.toggleSlider} />
                        </label>
                    </div>
                );
            })}
        </div>
    );
}
